import { useState } from 'react';

interface PlacePhotoGalleryProps {
  photos: string[];
  fallbackUrl: string | null;
}

export function PlacePhotoGallery({ photos, fallbackUrl }: PlacePhotoGalleryProps) {
  const [index, setIndex] = useState(0);

  const images = photos.length > 0 ? photos : fallbackUrl ? [fallbackUrl] : [];
  if (images.length === 0) return null;

  const safeIndex = Math.min(index, images.length - 1);
  const showNav = images.length > 1;

  const prev = () => setIndex((i) => (i - 1 + images.length) % images.length);
  const next = () => setIndex((i) => (i + 1) % images.length);

  return (
    <div style={{ position: 'relative', width: '100%', height: 280 }}>
      <img
        src={images[safeIndex]}
        alt=""
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          borderRadius: '8px 8px 0 0',
          display: 'block',
        }}
      />
      {showNav && (
        <>
          <button
            onClick={prev}
            style={{
              position: 'absolute',
              left: 6,
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'rgba(0,0,0,0.45)',
              color: '#fff',
              border: 'none',
              borderRadius: '50%',
              width: 28,
              height: 28,
              fontSize: 16,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            ‹
          </button>
          <button
            onClick={next}
            style={{
              position: 'absolute',
              right: 6,
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'rgba(0,0,0,0.45)',
              color: '#fff',
              border: 'none',
              borderRadius: '50%',
              width: 28,
              height: 28,
              fontSize: 16,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            ›
          </button>
          <div
            style={{
              position: 'absolute',
              bottom: 6,
              left: '50%',
              transform: 'translateX(-50%)',
              display: 'flex',
              gap: 5,
            }}
          >
            {images.map((_, i) => (
              <span
                key={i}
                onClick={() => setIndex(i)}
                style={{
                  width: 7,
                  height: 7,
                  borderRadius: '50%',
                  background: i === safeIndex ? '#fff' : 'rgba(255,255,255,0.5)',
                  cursor: 'pointer',
                  display: 'inline-block',
                }}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
